import { createSelector } from 'reselect/lib/index';
import { get, camelCase } from 'lodash';

export const userCommunitiesSelector = state =>
  get(state, 'communities.userCommunities');
export const discoverCommunitiesSelector = state =>
  get(state, 'communities.reqDiscoverCommunities');
export const currentCommunityIdSelector = state =>
  get(state, 'communities.currentCommunity');
export const communityJoinPopupSelector = state =>
  get(state, 'communities.joinPopup');
export const reqMemberInvitationSelector = state =>
  get(state, 'communities.reqMemberInvitation');

export const selectCommunityImageUpdateState = state =>
  get(state, 'communities.communityImageUpdate');
export const selectCommunityImageRemoveState = state =>
  get(state, 'communities.communityImageRemove');

export const membersListLengthSelector = state =>
  get(state, 'communities.membersList.length');
export const moderatorsListLengthSelector = state =>
  get(state, 'communities.moderatorsList.length');
export const selectCreateCommunityPost = state =>
  get(state, 'communities.createPost');

// user communities
export const sendingUserCommunitiesSelector = createSelector(
  userCommunitiesSelector,
  request => get(request, 'sending', false),
);

export const makeUserCommunitiesListSelector = userRole =>
  createSelector(
    userCommunitiesSelector,
    request => get(request, [userRole], []),
  );

export const communityUnreadCountSelector = communityId =>
  createSelector(
    makeUserCommunitiesListSelector('memberCommunities'),
    makeUserCommunitiesListSelector('moderatorCommunities'),
    (memberList, moderatorList) => {
      const list = [...memberList, ...moderatorList];
      const community = list.find(item => get(item, 'id') === communityId);
      const counter = get(
        community,
        'communityMemberChatroom.totalUnreadCount',
        0,
      );
      return counter;
    },
  );

export const makeUserCommunitiesPaginationSelector = userRole =>
  createSelector(
    userCommunitiesSelector,
    communitiesState => get(communitiesState, ['pagination', userRole]),
  );

export const makeUserCommunitiesCounterSelector = communityCount =>
  createSelector(
    userCommunitiesSelector,
    request => get(request, communityCount, 0),
  );

// discover communities
export const sendingDiscoverCommunitiesSelector = createSelector(
  discoverCommunitiesSelector,
  request => get(request, 'sending', false),
);

export const makeDiscoverCommunitiesListSelector = communityType =>
  createSelector(
    discoverCommunitiesSelector,
    request => get(request, [communityType], []),
  );

export const makeDiscoverCommunitiesCounterSelector = communityCount =>
  createSelector(
    discoverCommunitiesSelector,
    request => {
      const counterName = camelCase(`${communityCount}_count`);

      return get(request, ['meta', counterName], 0);
    },
  );

export const makeDiscoverCommunitiesPaginationSelector = communityType =>
  createSelector(
    discoverCommunitiesSelector,
    communitiesState => get(communitiesState, ['pagination', communityType]),
  );

export const reqMemberInvitationErrorSelector = createSelector(
  reqMemberInvitationSelector,
  request => get(request, 'error', false),
);

export const selectMemberInvitationTargetUser = createSelector(
  reqMemberInvitationSelector,
  state => get(state, 'targetUser'),
);

export const selectCommunityImageProcessing = createSelector(
  selectCommunityImageUpdateState,
  selectCommunityImageRemoveState,
  (updateState, removeState) => {
    return get(updateState, 'sending') || get(removeState, 'sending');
  },
);

// Invitation Search Selectors
export const selectCommunityInvitationSearchState = state =>
  get(state, 'communities.invitationUserSearch');

export const selectCommunityInvitationSearchUsers = createSelector(
  selectCommunityInvitationSearchState,
  state => get(state, 'list', []),
);
export const selectCommunityInvitationSearchSending = createSelector(
  selectCommunityInvitationSearchState,
  state => get(state, 'sending', false),
);
export const selectCommunityInvitationSearchSucceed = createSelector(
  selectCommunityInvitationSearchState,
  state => get(state, 'succeed') || false,
);

// Invitation Accept/Decline selectors
export const selectInviteAcceptState = state =>
  get(state, 'communities.acceptInvitation');
export const selectInviteDeclineState = state =>
  get(state, 'communities.declineInvitation');

export const selectAcceptDeclinePending = createSelector(
  selectInviteAcceptState,
  selectInviteDeclineState,
  ({ sending: acceptSending }, { sending: declineSending }) =>
    acceptSending || declineSending,
);



// WEBPACK FOOTER //
// ./src/redux/communities/selectors/selectors.js